import type { ConnectedPosition } from '@angular/cdk/overlay';

import type { Observable } from 'rxjs';

import type { KeyboardEventCode } from '@core/common-legacy/keyboard';

import type { OverlayPosition } from '../../editor/types';
import { EditorEvent } from '../../editor/types';

export enum MentionType {
  User = 'user',
  Role = 'role',
}

interface WithTooltip {
  tooltip: string;
}

export interface MentionElementGroup<T = any> {
  header?: string;
  disabled?: boolean;
  data: Array<MentionElement<T> & Partial<WithTooltip>>;
}

export interface MentionElement<T = any> {
  id: number;
  type: MentionType;
  name: string;
  avatar: string;
  entity?: T;
  initials: string;
  hasAvatar: boolean;
}

export type MentionNavigationKey =
  | KeyboardEventCode.ArrowUp
  | KeyboardEventCode.ArrowDown
  | KeyboardEventCode.Enter;

export enum MentionInternalStrategy {
  Default = 'Default',
  Grouped = 'Grouped',
}

export abstract class MentionsPluginEvent extends EditorEvent {
  protected constructor(type: string) {
    super('EmojiPlugin', type);
  }
}

export class MentionsPluginPickerBeforeOpen extends MentionsPluginEvent {
  constructor() {
    super('pickerOpen');
  }
}

export class MentionsPluginPickerClose extends MentionsPluginEvent {
  constructor() {
    super('pickerClose');
  }
}

export type MentionsPluginEvents = MentionsPluginPickerBeforeOpen | MentionsPluginPickerClose;

export interface MentionsListOpenOptions {
  withSearch?: boolean;
  preferredPositions?: ConnectedPosition[];
  queryChange?: (value: string) => void;
}

export interface MentionListController {
  open: (
    position: OverlayPosition | DOMRect,
    options?: MentionsListOpenOptions,
  ) => { element: HTMLElement; backdropClick$: Observable<MouseEvent> };
  setData: (data: MentionElement[] | MentionElementGroup[]) => void;
  setSelectCallback: (selectCb: (val: MentionElement) => void) => void;
  close: () => void;
  updatePosition: (position: OverlayPosition) => void;
  isOpen: () => boolean;
  handleKey: (key: MentionNavigationKey) => void;
  registerRestoreFocus: (restoreFocusCallback: () => void) => void;
}
